import {Injectable} from '@angular/core';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class NotificationSoundService {

  notificationSound: HTMLAudioElement;

  constructor() {
    this.notificationSound = new Audio('./assets/audio/hangouts_message.mp3');
    // Agregamos la opción de bucle
    this.notificationSound.loop = true;

    // Validamos si el archivo de audio se cargó correctamente
    if (this.notificationSound.error) {
      return;
    }

    // Validamos si la ruta del archivo de audio es correcta
    if (!this.notificationSound.src) {
      return;
    }

  }

  requestPermission(): Observable<NotificationPermission> {
    return new Observable<NotificationPermission>(observer => {
      if (!('Notification' in window)) {
        observer.next('default');
        observer.complete();
      } else if (Notification.permission !== 'default') {
        observer.next(Notification.permission);
        observer.complete();
      } else {
        Notification.requestPermission().then(permission => {
          observer.next(permission);
          observer.complete();
        });
      }
    });
  }

  playNotificationSound() {
    this.notificationSound.play();
  }

  stopNotificationSound() {
    this.notificationSound.pause();
    this.notificationSound.currentTime = 0;
  }

}
